import { useAppSelector } from "../../app/hooks"
import { RootState } from "../../app/store"
import { ReleaseDetailsDialog } from "../system/releases/ReleaseDetailsDialog"
import { HelpDialog } from "./HelpDialog"

export const AppDialogDispatcher = () => {
    const dialogState = useAppSelector((state: RootState) => state.dialog)

    switch (dialogState.tag) {
        case 'none': return null
        case 'help': return <HelpDialog {...dialogState.props} />
        case 'releaseDetails': return <ReleaseDetailsDialog {...dialogState.props} />
    }
}

